import * as I from 'immutable';

import {ApiOrganizationUser} from 'app/modules/Remote/Organization';

export const ORG_USERS: ApiOrganizationUser[] = [
  {
    id: '1a',
    email: 'marshall@upstream.tech',
    name: 'Marshall Moutenot',
    organizationKey: '6e04f009-7309-4e38-a442-476948c4d7f5',
    role: 'owner' as const,
    organizations: [],
    settings: {},
  },
  {
    id: '2b',
    email: 'alden@upstream.tech',
    name: 'Alden Keefe Sampson',
    organizationKey: '6e04f009-7309-4e38-a442-476948c4d7f5',
    role: 'owner' as const,
    organizations: [],
    settings: {},
  },
  {
    id: '3c',
    email: 'emily@upstream.tech',
    name: 'Emily',
    organizationKey: '6e04f009-7309-4e38-a442-476948c4d7f5',
    role: 'regular' as const,
    organizations: [],
    settings: {},
  },
  {
    id: '4d',
    email: 'danielkatz125@gmail.com',
    name: 'Dan',
    organizationKey: '6e04f009-7309-4e38-a442-476948c4d7f5',
    role: 'regular' as const,
    organizations: [],
    settings: {},
  },
  {
    id: '5e',
    email: 'bob@upstream.tech',
    name: 'Robert Frost',
    organizationKey: '6e04f009-7309-4e38-a442-476948c4d7f5',
    role: 'readonly' as const,
    organizations: [],
    deletedLocally: true,
    settings: {},
  },
  {
    id: '6f',
    email: 'fiona@upstream.tech',
    name: 'Fiona',
    organizationKey: '6e04f009-7309-4e38-a442-476948c4d7f5',
    role: 'regular' as const,
    organizations: [],
    settings: {},
  },
];

export const REGULAR_USER = I.fromJS(ORG_USERS.find((u) => u!.role === 'regular'));
export const OWNER_USER = I.fromJS(ORG_USERS.find((u) => u!.role === 'owner'));
export const READONLY_USER = I.fromJS(ORG_USERS.find((u) => u!.role === 'readonly'));

// The `admin` role is owner-equivalent. Kept out of ORG_USERS so the shared
// org-user list (and the snapshots that render it) stays unchanged.
const ADMIN_ORG_USER: ApiOrganizationUser = {
  id: '7g',
  email: 'ada-admin@upstream.tech',
  name: 'Ada Admin',
  organizationKey: '6e04f009-7309-4e38-a442-476948c4d7f5',
  role: 'admin' as const,
  organizations: [],
  settings: {},
};
export const ADMIN_USER = I.fromJS(ADMIN_ORG_USER);
